module.exports = __webpack_public_path__ + "img/benefit-revenue.02d07517.svg";